import { FunctionComponent, useMemo, useState, useEffect, Ref, forwardRef } from "react";
// import alerticonError from "../../assets/error-message-icon/alert-icon-error.svg";
import InputMask from "react-input-mask-next";


interface InputsNewProps {
  label?: string;
  contentPlaceholder?: string | number;
  propMinWidth?: string;
  propMinWidth1?: string;
  type: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onPaste?: any;
  autoComplete?: any;
  value?: string | number;
  imgSrc?: string;
  disabled?: boolean;
  register?: any;
  errorMessage?: any;
  maxValue?: any;
  className?: any;
  ssnField?: boolean;
  defaultValue?: any;
  step?: string;
  errorMessage1?: any;
  onInput?: any;
  parentClass?:any;
  readOnly?: boolean;
}

const InputsNew = forwardRef<HTMLInputElement, InputsNewProps>((props) => {
  const {
    label,
    contentPlaceholder,
    propMinWidth,
    propMinWidth1,
    type,
    onChange,
    onKeyDown,
    autoComplete,
    onPaste,
    value,
    imgSrc,
    disabled,
    register,
    errorMessage,
    maxValue,
    className,
    ssnField,
    defaultValue,
    step,
    errorMessage1,
    onInput,
    parentClass,
    readOnly,
  } = props
  const inputsStyle = useMemo(() => {
    return {
      minWidth: propMinWidth,
    };
  }, [propMinWidth]);
  
  const contentStyle = useMemo(() => {
    return {
      minWidth: propMinWidth1,
    };
  }, [propMinWidth1]);

  const borderClass = errorMessage || errorMessage1
    ? "border-2 border-rose-500 dark:border-rose-500 darkinputborder"
    : "border-surface-border";
  const inputClass = `inputborder_css_dv mt-id-dv self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-radius-md bg-text-text-tertiary overflow-hidden flex flex-row items-center justify-start py-2.5 px-[15px] dark:bg-slate-700 border-[1px] border-solid  ${borderClass} ${parentClass}`;

  const InputComponent = type === "textarea" ? "textarea" : "input";

  if (type === "tel") {
    return (
      <div
        className="self-stretch flex-1 inputnew-div flex flex-col items-start justify-start gap-[8px] 
        text-left text-sm text-text-text-primary font-body-reg  dark:text-white"
        style={inputsStyle}
      >
        {label && (
          <label className="self-stretch relative font-semibold  dark:text-white">{label}</label>
        )}

        {/* <div className="self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-radius-md bg-text-text-tertiary overflow-hidden flex flex-row items-center justify-start py-2.5 px-[15px] border-[1px] border-solid border-surface-border"> */}
        <div className={`${inputClass} ${disabled == true ? "caretask_dropdowndisbale pointer-events-auto cursor-not-allowed" : ""}`}>
          <span className="text-sm text-text-text-secondary dark:text-white">+1</span>
          <InputMask
            mask=" (999) 999-9999"
            className="w-full [border:none] [outline:none] bg-[transparent] h-[19px] flex flex-row items-center justify-start font-body-reg text-sm text-text-text-secondary dark:text-white"
            placeholder={contentPlaceholder}
            type="tel"
            style={contentStyle}
            defaultValue={value}
            disabled={disabled ? disabled : false}
            {...register}
            autoComplete="off"
          />
          {imgSrc && (
            <img
              className="h-[25px] w-[25px] relative overflow-hidden shrink-0 cursor-pointer"
              loading="lazy"
              alt=""
              src={imgSrc}
            />
          )}
        </div>
        {errorMessage && (
          <p className="text-red p-2 cts-bg-error my-0 flex items-center gap-[4px] ctcerror-width-blg">
            <img alt="" /> {errorMessage.message}
          </p>
        )}

      </div>
    );
  } else if (ssnField && type === "text") {
    return (
      <div
        className="self-stretch flex-1 inputnew-div flex flex-col items-start justify-start gap-[8px] text-left text-sm text-text-text-primary font-body-reg"
        style={inputsStyle}
      >
        <label className="self-stretch relative font-semibold dark:text-white">{label}</label>
        {/* <div className="self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-radius-md bg-text-text-tertiary overflow-hidden flex flex-row items-center justify-start py-2.5 px-[15px] border-[1px] border-solid border-surface-border"> */}
        <div className={`${inputClass} ${disabled == true ? "caretask_dropdowndisbale pointer-events-auto cursor-not-allowed" : ""}`}>
          <InputMask
            mask="999-99-9999"
            className="w-full [border:none] [outline:none] bg-[transparent] h-[19px] flex flex-row items-center justify-start font-body-reg text-sm text-text-text-secondary dark:text-white"
            placeholder={contentPlaceholder}
            type="text"
            style={contentStyle}
            onChange={onChange}
            value={value}
            disabled={disabled ? disabled : false}
            autoComplete="off"
            {...register}
          />
          {imgSrc && (
            <img
              className="h-[25px] w-[25px] relative overflow-hidden shrink-0 cursor-pointer"
              loading="lazy"
              alt=""
              src={imgSrc}
            />
          )}
        </div>
        {errorMessage && (
          <p className="text-red p-2 cts-bg-error my-0 flex items-center gap-[4px] ctcerror-width-blg">
            <img alt="" /> {errorMessage.message}
          </p>
        )}
      </div>
    );
  } else if ((defaultValue && type === "text") || type === "number") {
    return (
      <div
        className={`self-stretch flex-1 inputnew-div flex flex-col items-start justify-start gap-[8px] text-left text-sm text-text-text-primary font-body-reg`}
        style={inputsStyle}
      >
        <label className="self-stretch relative font-semibold dark:text-white">{label}</label>
        {/* <div className="self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-radius-md bg-text-text-tertiary overflow-hidden flex flex-row items-center justify-start py-2.5 px-[15px] border-[1px] border-solid border-surface-border"> */}
        <div className={`${inputClass} ${disabled == true ? "caretask_dropdowndisbale pointer-events-auto cursor-not-allowed" : ""}`}>
          <input
            className={`w-full [border:none] [outline:none] bg-[transparent] h-[19px] flex-1 flex flex-row items-center justify-start font-body-reg text-sm dark:text-white text-text-text-secondary ${className}`}
            placeholder={contentPlaceholder}
            type="text"
            style={contentStyle}
            onChange={onChange}
            onKeyDown={onKeyDown}
            onInput={onInput}
            autoComplete={autoComplete || 'off'}
            onPaste={onPaste}
            defaultValue={defaultValue}
            disabled={disabled ? disabled : false}
            maxLength={maxValue}
            {...register}
          />
          {imgSrc && (
            <img
              className="h-[25px] w-[25px] relative overflow-hidden shrink-0 cursor-pointer"
              loading="lazy"
              alt=""
              src={imgSrc}
            />
          )}
        </div>
        {errorMessage && (
          <p className="text-red p-2 my-0 cts-bg-error flex items-center gap-[4px] ctcerror-width-blg">
            <img alt="" /> {errorMessage.message}
          </p>
        )}
      </div>
    );
  } else if (type === "textarea") {
    // compoent for multine (eg: notes, reasons etc.)
    return (
      <div
        className="self-stretch flex-1 inputnew-div flex flex-col items-start justify-start gap-[8px] ctc-gap-carybot text-left text-sm text-text-text-primary font-body-reg"
        style={inputsStyle}
      >
        <label className="self-stretch relative font-semibold dark:text-white">{label}</label>
        <div
          className={`inputborder_css_dv self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] dark:bg-slate-700 rounded-radius-md bg-text-text-tertiary overflow-hidden flex flex-row items-center justify-start py-2.5 px-[15px] border-[1px] border-solid ${borderClass} ${disabled == true ? "caretask_dropdowndisbale pointer-events-auto cursor-not-allowed" : ""}`}
        >
          <InputComponent
            className={`w-full [border:none] [outline:none] min-h-20  bg-[transparent] h-[19px] flex-1 flex flex-row items-center justify-start font-body-reg text-sm dark:text-white text-text-text-secondary ${className}`}
            placeholder={contentPlaceholder}
            type={type === "textarea" ? undefined : type}
            style={contentStyle}
            onChange={onChange}
            onKeyDown={onKeyDown}
            defaultValue={defaultValue}
            value={value}
            disabled={disabled ? disabled : false}
            readOnly={readOnly}
            maxLength={maxValue}
            step={step}
            autoComplete="off"
            {...register}
          />
          {imgSrc && (
            <img
              className="h-[25px] w-[25px] relative overflow-hidden shrink-0 cursor-pointer"
              loading="lazy"
              alt=""
              src={imgSrc}
            />
          )}
        </div>
        {errorMessage && (
          <p className="text-red p-2 my-0 cts-bg-error flex items-center gap-[4px] ctcerror-width-blg">
            <img alt="" /> {errorMessage.message}
          </p>
        )}
      </div>
    );
  } else {
    return (
      <div
        className="self-stretch flex-1 inputnew-div flex flex-col items-start justify-start mq480:gap-[8px] gap-[8px] ctc-gap-carybot text-left text-sm text-text-text-primary font-body-reg dark:bg-slate-800 "
        style={inputsStyle}
      >
        <label className="self-stretch relative font-semibold dark:text-white">{label}</label>
        {/* <div className="self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-radius-md bg-text-text-tertiary overflow-hidden flex flex-row items-center justify-start py-2.5 px-[15px] border-[1px] border-solid border-surface-border"> */}
        <div className={`${inputClass} ${disabled == true ? "caretask_dropdowndisbale pointer-events-auto cursor-not-allowed" : ""}`} id="innertblinput-bg">
          <InputComponent
            className={`w-full [border:none] [outline:none] bg-[transparent] h-[19px] flex-1 flex flex-row items-center justify-start font-body-reg text-sm dark:text-white text-text-text-secondary ${className}`}
            placeholder={contentPlaceholder}
            type={type === "textarea" ? undefined : type}
            style={contentStyle}
            onChange={onChange}
            onKeyDown={onKeyDown}
            autoComplete={autoComplete || 'off'}
            onPaste={onPaste}
            value={value}
            disabled={disabled ? disabled : false}
            maxLength={maxValue}
            step={step}
            {...register}
          />
          {imgSrc && (
            <img
              className="h-[25px] w-[25px] relative overflow-hidden shrink-0 cursor-pointer dark-white-img"
              loading="lazy"
              alt=""
              src={imgSrc}
            />
          )}
        </div>
        {errorMessage && (
          <p className="text-red p-2 my-0 cts-bg-error flex items-center gap-[4px] ctcerror-width-blg">
            <img className="" alt="" /> {errorMessage.message}
          </p>
        )}
      </div>
    );
  }
})

export default InputsNew;
